module.exports = __webpack_public_path__ + "static/media/lock.75a5a190.svg";